var _style, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPdpd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xEB\\xCE\\xD3\\xC8_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2850.34 1195.19",
    style: {
      enableBackground: "new 0 0 2850.34 1195.19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000144297931347901427550000011457889975182245538_);}\n\t.st2{fill:url(#SVGID_00000144325909021813004080000012567963013528432279_);}\n\t.st3{fill:url(#SVGID_00000175305787400637807830000006549251380182236037_);}\n\t.st4{fill:url(#SVGID_00000049190798866154508480000006140856490792080292_);}\n\t.st5{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -29.1279,
    y1: 619.2879,
    x2: 2800.1799,
    y2: 593.4789,
    gradientTransform: "matrix(-1 0 0 1 2850.9583 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007DFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M764.05,960.31V194.79h1976.1c60.76,0,110.19,50.44,110.19,112.45v603.53c0,62-49.43,112.44-110.19,112.44 H763.6C763.72,1002.24,764.05,981.27,764.05,960.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158019331987128998030000010260223393968629664_",
    gradientUnits: "userSpaceOnUse",
    x1: 1776.7618,
    y1: 230.3987,
    x2: 1776.7618,
    y2: 1006.1227
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005A9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#002756"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158019331987128998030000010260223393968629664_)"
    },
    d: "M748.29,972.66 c1.52-143.66,2.9-287.31,3.9-430.97c0.7-100.39,1.2-200.78,1.44-301.17h1998.63c29.28,0,53.02,24.22,53.02,54.1v628.77 c0,29.88-23.74,54.11-53.02,54.11H748.24C748.26,975.88,748.28,974.27,748.29,972.66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153677788504057217310000017615636723035624576_",
    gradientUnits: "userSpaceOnUse",
    x1: 2296.5962,
    y1: -17.7413,
    x2: 2305.009,
    y2: 1247.0582,
    gradientTransform: "matrix(-1 0 0 1 2850.9583 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007DFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153677788504057217310000017615636723035624576_)"
    },
    d: "M589.26,1180.78 c77.01-29.96,149.01-75.25,214.01-134.61c62.17-56.78,116.64-125.23,161.88-203.45c44.64-77.18,79.27-162.12,102.94-252.43 c24.11-92.02,36.34-187.82,36.34-284.73c0-49.45-3.28-99.45-9.75-148.62l-16.42-124.79L960.51,69.8 c-43.11,13.78-88.02,20.77-133.48,20.77c-77.49,0-154.78-21.04-223.5-60.83L552.19,0l-51.34,29.75 c-0.76,0.44-1.52,0.85-2.28,1.27l-0.24,0.13c-1.09,0.6-2.17,1.2-3.25,1.8c-67.27,37.69-142.55,57.61-217.69,57.61 c-45.46,0-90.37-6.99-133.47-20.77L26.18,32.15L9.75,156.94C3.28,206.11,0,256.11,0,305.56c0,96.05,12.01,191.03,35.71,282.3 c23.25,89.57,57.3,173.92,101.2,250.7c44.45,77.76,98.01,146.03,159.19,202.91c63.89,59.4,134.75,105.13,210.6,135.9l1.85,0.75 c2.15,0.88,4.37,1.78,6.6,2.65l37.06,14.41L589.26,1180.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085227690961178481100000002266098488760518552_",
    gradientUnits: "userSpaceOnUse",
    x1: 1371.2587,
    y1: 56.68,
    x2: 1376.0176,
    y2: 1158.3298,
    gradientTransform: "matrix(-1 0 0 1 1924.5453 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00BEFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085227690961178481100000002266098488760518552_)"
    },
    d: "M564.56,1114.67 c69.06-26.87,133.82-67.65,192.47-121.22c56.86-51.92,106.79-114.74,148.4-186.69c41.44-71.65,73.63-150.63,95.67-234.75 c22.55-86.06,33.99-175.71,33.99-266.45c0-46.31-3.07-93.14-9.13-139.2l-5.47-41.6l-39.25,12.55 c-49.83,15.93-101.71,24.01-154.21,24.01c-89.47,0-178.58-24.22-257.72-70.05l-17.11-9.91l-17.11,9.92 c-1.27,0.74-2.56,1.44-3.84,2.15c-0.94,0.52-1.88,1.04-2.82,1.56c-77.46,43.4-164.27,66.34-251.05,66.34 c-52.5,0-104.38-8.08-154.2-24.01l-39.25-12.55l-5.48,41.6c-6.06,46.05-9.14,92.88-9.14,139.2 c0,89.93,11.24,178.81,33.4,264.18c21.66,83.43,53.3,161.88,94.06,233.17c40.91,71.55,90.03,134.22,146,186.27 c57.69,53.64,121.46,94.84,189.52,122.46l1.95,0.79c1.86,0.76,3.73,1.52,5.6,2.25l12.35,4.8L564.56,1114.67z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018951226570452841770000008601381158053682311_",
    gradientUnits: "userSpaceOnUse",
    x1: 1372.3334,
    y1: 122.0351,
    x2: 1372.3334,
    y2: 1081.6161,
    gradientTransform: "matrix(-1 0 0 1 1924.5453 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005A9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#002756"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018951226570452841770000008601381158053682311_)"
    },
    d: "M112.82,171.07 c53.24,17.02,108.37,25.63,164.56,25.63c93.25,0,185.06-24.39,267.73-70.7c2.36-1.32,4.74-2.6,7.09-3.96 c84.49,48.93,178.91,74.66,274.83,74.66c56.19,0,111.33-8.6,164.57-25.63c5.87,44.57,8.83,89.61,8.83,134.49 c0,356.83-183.52,673.07-448.22,776.06c-2.38-0.92-4.73-1.9-7.09-2.86c-260.87-105.84-441.12-419.56-441.12-773.2 C103.99,260.67,106.96,215.62,112.82,171.07z"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M398.07,472.06h2.97v-54.97c0-83.15,66.29-150.8,147.77-150.8c81.48,0,147.77,67.65,147.77,150.8v54.97h9.76 c19.21,0,34.78,15.89,34.78,35.49v227.22c0,19.6-15.57,35.49-34.78,35.49H398.07c-19.21,0-34.78-15.89-34.78-35.49V507.55 C363.29,487.95,378.86,472.06,398.07,472.06z M538.25,635.55v51.41c0,7.87,6.25,14.25,13.97,14.25h0c7.71,0,13.97-6.38,13.97-14.25 v-51.41c6.35-4.51,10.51-12,10.51-20.49c0-13.79-10.96-24.98-24.47-24.98c-13.52,0-24.47,11.18-24.47,24.98 C527.74,623.55,531.9,631.04,538.25,635.55z M442.45,417.09v54.97h212.74v-54.97h0.02c0-59.86-47.73-108.56-106.38-108.56 c-58.66,0-106.39,48.7-106.39,108.56H442.45z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1337.39,805.58h-100.15V412.41h159.43c43.26,0,76.39,11.47,99.39,34.41c23,22.94,34.49,55.27,34.49,96.99 c0,41.72-11.5,74.05-34.49,96.99c-22.99,22.94-56.13,34.41-99.39,34.41h-59.27V805.58z M1337.39,592.83h33.21 c36.79,0,55.19-16.33,55.19-49.02c0-32.67-18.4-49.02-55.19-49.02h-33.21V592.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1583.68,412.41h148.18c26.23,0,50.84,5.39,73.84,16.16c22.99,10.78,43.09,25.12,60.3,43.02 c17.2,17.91,30.74,38.77,40.62,62.57c9.88,23.81,14.82,48.75,14.82,74.83c0,25.73-4.85,50.5-14.56,74.31 c-9.71,23.81-23.17,44.76-40.37,62.83c-17.21,18.08-37.3,32.51-60.3,43.28c-22.99,10.78-47.78,16.16-74.35,16.16h-148.18V412.41z  M1683.83,719.02h23c17.37,0,32.87-2.78,46.5-8.34c13.62-5.56,25.12-13.21,34.49-22.95c9.37-9.73,16.52-21.29,21.46-34.67 c4.93-13.38,7.41-28.07,7.41-44.06c0-15.64-2.55-30.24-7.66-43.8c-5.11-13.56-12.35-25.2-21.72-34.94 c-9.37-9.73-20.87-17.38-34.49-22.94c-13.63-5.56-28.96-8.34-45.99-8.34h-23V719.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2085.46,805.58h-100.15V412.41h159.43c43.26,0,76.39,11.47,99.39,34.41c23,22.94,34.49,55.27,34.49,96.99 c0,41.72-11.5,74.05-34.49,96.99c-22.99,22.94-56.13,34.41-99.39,34.41h-59.27V805.58z M2085.46,592.83h33.21 c36.79,0,55.19-16.33,55.19-49.02c0-32.67-18.4-49.02-55.19-49.02h-33.21V592.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2546.37,737.28h-143.08l-22.99,68.31H2273.5l146.65-393.17h109.35l146.65,393.17h-106.8L2546.37,737.28z  M2519.79,659.58l-44.97-130.88l-44.97,130.88H2519.79z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPdpd);
export default __webpack_public_path__ + "static/media/logoPdpd.56166442ccd7f53d7d25c424bfd88f44.svg";
export { ForwardRef as ReactComponent };